import { BACKEND_URLS } from '../config/backends';
import { DEVSUPPORT, LIVEVIEW, LOGIN } from '@core/router/app-states';
import { EnvironmentConfigType } from './environment-config-type';
import { COMMON_CONFIG } from './common-config';

export const environment: EnvironmentConfigType = {
  production: true,
  testingEnabled: false,
  flavour: 'default',
  settings: {
    url: 'https://app.inhousedelivery.com/',
    defaultLocale: 'en-US',
    grid: {
      numberOfSlotsPerDay: 96
    },
    plans: {
      ...COMMON_CONFIG.settings.plans
    },
    referrals: {
      ...COMMON_CONFIG.settings.referrals,
    },
    home_dev_support: DEVSUPPORT,
    home_employer: LIVEVIEW,
    setup_employer: LIVEVIEW,
    poll_dev_support_orders_interval: 60000,
    poll_print_ready_interval: 5000,
    poll_export_ready_interval: 5000,
    poll_notices_interval: 10000,
    poll_global_interval: 5 * 60 * 1000,
    poll_chat_internal: 10000,
    poll_live_orders_interval: 60000,
    poll_live_report_interval: 60000,
    poll_onboard_fetch_interval: 60000,
    poll_onboard_heartland_fetch_interval: 60000,
    poll_onboard_heartland_interval: 2000,
    poll_orders_interval: 60000, 
    poll_live_attendance_interval: 60000, 
    logged_in_refresh_interval: 10 * 60 * 1000,
    listPerPage: 20,
    endpoint_root: '.inhousedelivery.com',
    freeCloudStorageMaxDayRange: 28,
    localStoragePrefix: 'ihd_local_storage'
  },
  value: 'production',
  oauth: {
    clientId: 'zfwsdNZGSB3pkZw8l5b2QRQZ12HtWMgI4G2C0u32',
    clientSecret: 'AweqBOIZVbheDve6bRhrrfEYyrdfh8YMB7JL5v4z'
  },
  google: {
    key: 'AIzaSyDWuiQnrl_NUYn0XXlUgTfKqsa9sXp9Et4',
    mapId: 'e0588c2bb6ea34c3'
  },
  api: {
    endpointBase: `${ BACKEND_URLS['PROD'] }`,
    endpoint: `${ BACKEND_URLS['PROD'] }${ '/v3' }`,
    endpointV2:`${ BACKEND_URLS['PROD'] }${ '/v2' }`,
    endpointAuth:`${ BACKEND_URLS['PROD'] }${ '/auth' }`,
    refer: 'https://oss.ws/r',
    util: 'https://oss.ws',
  },
  default: {
    support: 'https://www.inhousedelivery.com/for-customers',
  },
  paths: {
    login: {
      url: `/${ LOGIN }`,
    },
    restricted: {
      url: '/error/restricted',
    },
    home: {
      employerIHD: {
          url: `/${ LIVEVIEW }`,
          state: LIVEVIEW,
      },
      employer: {
        url: `/${ LIVEVIEW }`,
        state: LIVEVIEW,
      },
    },
  },
  logger: {
    environment: {
        production: false,
        others: true,
    },
  },
  routes: {
    ...COMMON_CONFIG.routes,
  },
  intercom: {
    app_id: 'lc8j2j2n',
  },
  assets: {
    localeUrl:
        'https://resources.inhousedelivery.com/locales/:locale/generic.json', // en-US
    globalUrl:
        'https://resources.opensimsim.com/assets/global_playground.json',
    articlesUrl: 'https://resources.opensimsim.com/assets/articles',
    feedbackUrl: 'https://inhousedelivery.canny.io/feature-requests',
    settingsUrl:
        'https://resources.opensimsim.com/assets/settings/settings_playground.json',
    formatUrl:
        'https://resources.opensimsim.com/assets/settings/format/web-1-0.json',
    staticCloudinaryImages:
        'https://res.cloudinary.com/open-simsim/image/upload/',
  },
  ihd: {
    coverage: {
        doordash:
            'https://resources.opensimsim.com/assets/ihd-coverage/doordash/coverage.json',
    },
    tcUrl: 'https://oss.ws/terms',
    privacyUrl: 'https://oss.ws/privacy'
  }
};
